(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gomint-energy-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(section) {
      if (section.__gmetReady) return;
      section.__gmetReady = true;
      if (!section.classList.contains('gmet--armed')) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { section.classList.remove('gmet--armed'); return; }

      var replay = section.dataset.replay === 'true';
      var trigger = (parseFloat(section.dataset.trigger) || 65) / 100;
      var rail = section.querySelector('.gmet__rail');
      var moments = Array.prototype.slice.call(section.querySelectorAll('.gmet__moment'));
      if (!rail || !moments.length) return;
      var best = 0, ticking = false;

      // The rail fills down to a "reveal line" on the screen. Each step lights up
      // only when the tip of the fill reaches that step's marker.
      function update() {
        ticking = false;
        var rr = rail.getBoundingClientRect();
        if (!rr.height) return;
        var line = window.innerHeight * trigger;
        var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        var fill = atBottom ? rr.height : Math.min(Math.max(line - rr.top, 0), rr.height);
        if (!replay) { best = Math.max(best, fill); fill = best; }
        section.style.setProperty('--gmet-p', (fill / rr.height).toFixed(4));
        moments.forEach(function (m) {
          var mk = m.querySelector('.gmet__marker').getBoundingClientRect();
          var center = mk.top + mk.height / 2 - rr.top;
          if (fill >= center - 1) m.classList.add('is-active');
          else if (replay) m.classList.remove('is-active');
        });
      }
      function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

      // Only listen to scroll while the section is near the screen.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            window.addEventListener('scroll', onScroll, { passive: true });
            window.addEventListener('resize', onScroll);
          } else {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
          }
          update();
        });
      }, { rootMargin: '120px 0px' });
      io.observe(section);
    }
    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      if (scope.matches && scope.matches('[data-gmet]')) setup(scope);
      scope.querySelectorAll('[data-gmet]').forEach(setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gomint-flow-state"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(section) {
      if (section.__gfsReady) return;
      section.__gfsReady = true;
      if (!section.classList.contains('gfs--armed')) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { section.classList.remove('gfs--armed'); return; }
      var replay = section.dataset.replay === 'true';
      // Watch the graph itself (not the whole section) so the line only draws
      // once the chart is genuinely on screen.
      var target = section.querySelector('.gfs__graph') || section;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.remove('gfs--playing');
            void section.offsetWidth;
            section.classList.add('gfs--playing');
            if (!replay) observer.unobserve(target);
          } else if (replay) {
            section.classList.remove('gfs--playing');
          }
        });
      }, { threshold: 0.6, rootMargin: '0px 0px -6% 0px' });
      observer.observe(target);
    }
    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      if (scope.matches && scope.matches('[data-gfs]')) setup(scope);
      scope.querySelectorAll('[data-gfs]').forEach(setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gomint-how-to-take"] && !Shopify.designMode) return;
  try {
    
  function gmhowRespectMotion(root) {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.gmhow video').forEach(function(video) {
      video.pause();
      video.controls = true;
    });
  }
  gmhowRespectMotion(document);
  document.addEventListener('shopify:section:load', function(event) { gmhowRespectMotion(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gomint-no-fuss"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gmnf-toggle]');
    if (!button) return;
    var section = button.closest('.gmnf');
    if (!section) return;
    var playing = section.dataset.spin === 'true'
      ? !section.classList.contains('gmnf--paused')
      : section.classList.contains('gmnf--playing');
    section.classList.toggle('gmnf--paused', playing);
    section.classList.toggle('gmnf--playing', !playing);
    button.textContent = playing ? 'Play rotation' : 'Pause rotation';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gomint-sleep-flow-state"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(section) {
      if (section.__smflowReady) return;
      section.__smflowReady = true;
      if (!section.classList.contains('smflow--armed')) return;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) { section.classList.remove('smflow--armed'); return; }
      var replay = section.dataset.replay === 'true';
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.remove('smflow--playing');
            void section.offsetWidth;
            section.classList.add('smflow--playing');
            if (!replay) observer.unobserve(section);
          } else if (replay) section.classList.remove('smflow--playing');
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -5% 0px' });
      observer.observe(section);
    }
    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      if (scope.matches && scope.matches('[data-smflow]')) setup(scope);
      scope.querySelectorAll('[data-smflow]').forEach(setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-rotating"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(rot) {
      if (rot.__ehrReady) return;
      rot.__ehrReady = true;
      var words = (rot.dataset.words || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      if (words.length < 2) return;
      var typeMs = parseInt(rot.dataset.type, 10) || 90;
      var pauseMs = parseInt(rot.dataset.pause, 10) || 2000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;

      var wi = 0, ci = words[0].length, deleting = false;
      function tick() {
        var word = words[wi];
        if (!deleting) {
          ci++;
          if (ci >= word.length) {
            rot.textContent = word;
            deleting = true;
            return setTimeout(tick, pauseMs);
          }
          rot.textContent = word.slice(0, ci);
          return setTimeout(tick, typeMs);
        } else {
          ci--;
          rot.textContent = word.slice(0, ci);
          if (ci <= 0) {
            deleting = false;
            wi = (wi + 1) % words.length;
            return setTimeout(tick, typeMs * 2);
          }
          return setTimeout(tick, typeMs / 1.6);
        }
      }
      setTimeout(tick, pauseMs);
    }
    function init(root) {
      (root && root.querySelectorAll ? root : document).querySelectorAll('.ehr__rot').forEach(setup);
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', function () { init(); }); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-popular"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(card) {
      if (card.__mpReady) return;
      card.__mpReady = true;
      var subVal = card.querySelector('[data-price="sub"]');
      var oneVal = card.querySelector('[data-price="one"]');
      var saveEl = card.querySelector('.mp__save');
      var btn = card.querySelector('.mp__btn');
      var packs = card.querySelectorAll('.mp__pack');
      var prices = card.querySelectorAll('.mp__price');

      function rebuildHref() {
        if (!btn) return;
        var ap = card.querySelector('.mp__pack.is-active') || packs[0];
        if (!ap || !ap.dataset.variant) return; // manual mode → leave link as configured
        var pr = card.querySelector('.mp__price.is-active');
        var type = pr ? pr.dataset.type : 'one';
        var href = '/cart/' + ap.dataset.variant + ':1';
        if (type === 'sub' && ap.dataset.plan) href += '?selling_plan=' + ap.dataset.plan;
        btn.setAttribute('href', href);
      }

      packs.forEach(function (p) {
        p.addEventListener('click', function () {
          packs.forEach(function (x) { x.classList.remove('is-active'); });
          p.classList.add('is-active');
          if (subVal && p.dataset.sub) subVal.textContent = p.dataset.sub;
          if (oneVal && p.dataset.one) oneVal.textContent = p.dataset.one;
          if (saveEl) {
            var sv = p.dataset.save || '';
            saveEl.textContent = sv;
            if (sv) { saveEl.removeAttribute('hidden'); } else { saveEl.setAttribute('hidden', ''); }
          }
          rebuildHref();
        });
      });
      prices.forEach(function (pr) {
        pr.addEventListener('click', function () {
          prices.forEach(function (x) { x.classList.remove('is-active'); });
          pr.classList.add('is-active');
          rebuildHref();
        });
      });
      rebuildHref();
    }
    function init(root) {
      (root && root.querySelectorAll ? root : document).querySelectorAll('.mp__card').forEach(setup);
    }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', function () { init(); }); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
